"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var Rss = function Rss() {
  return _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M462,651H-46V143h508V651z M47.1,230.4V293c145.4,0,263.7,118.5,263.7,264h62.8C373.6,377,227.1,230.4,47.1,230.4z   M47,341.4V404c40.8,0,79.1,15.9,108,44.8c28.8,28.8,44.7,67.3,44.7,108.2h62.9C262.6,438.1,165.8,341.4,47,341.4z M90.5,469.9  c-24,0-43.5,19.6-43.5,43.4c0,24,19.5,43.3,43.5,43.3s43.5-19.3,43.5-43.3C134,489.5,114.6,469.9,90.5,469.9z"
  }));
};

Rss.displayName = 'Rss';
var _default = Rss;
exports["default"] = _default;
Rss.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Rss"
};

if (typeof STORYBOOK_REACT_CLASSES !== "undefined") {
  STORYBOOK_REACT_CLASSES["src/Rss.js"] = {
    name: "Rss",
    docgenInfo: Rss.__docgenInfo,
    path: "src/Rss.js"
  };
}